<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64">
        <v-toolbar flat color="white">
          <v-btn outlined class="mr-4 d-none" @click="setToday"><!-- hide for csr -->
            Today
          </v-btn>
          <!-- v-spacer /-->
          <v-btn fab text small @click="prev">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab text small @click="next">
            <v-icon small>mdi-chevron-right</v-icon>
          </v-btn>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer />
          <div ><!-- hide for csr -->
            <v-menu  bottom right>
              <template v-slot:activator="{ on }">
                <v-btn
                    outlined
                    v-on="on"
                >
                  <span>{{ typeToLabel[type] }}</span>
                  <v-icon right>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="type = 'day'">
                  <v-list-item-title>Day</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'week'" class="d-none">
                  <v-list-item-title>Week</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'month'">
                  <v-list-item-title>Month</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = '4day'" class="d-none">
                  <v-list-item-title>4 days</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-toolbar>
      </v-sheet>
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="yellow darken-2"
      />
      <v-sheet height="600">
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          :event-color="getEventColor"
          :event-margin-bottom="3"
          :type="type"
          :locale="$store.state.language"
          weekdays="1,2,3,4,5,6,0"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
          @change="updateRange"
        ></v-calendar>
        <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          full-width
          offset-x
        >
          <v-card
            color="grey lighten-4"
            min-width="350px"
            flat
          >
            <v-toolbar
              :color="selectedEvent.color"
              dark
            >
              <!-- v-btn icon>
                <v-icon>mdi-pencil</v-icon>
              </v-btn -->
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
              <v-spacer></v-spacer>
              <!-- v-btn icon>
                <v-icon>mdi-heart</v-icon>
              </v-btn>
              <v-btn icon>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn -->
            </v-toolbar>
            <v-card-text>
              {{ startDate }} <br>
              {{ endDate }} <br>
              <span v-html="selectedEvent.info"></span>
            </v-card-text>
            <v-card-actions>
              <v-btn
                text
                color="secondary"
                icon
                @click="selectedOpen = false"
              >
                <v-icon>fa-times</v-icon>
              </v-btn>
              <router-link
                v-if="selectedEvent.link"
                :to="selectedEvent.link"
                icon
                target="_blank"
                class="no-underline"
              >
                <v-btn
                  text
                  color="secondary"
                >
                  <v-icon>fa-edit</v-icon>
                </v-btn>
              </router-link>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment'

export default {
  name: 'CalendarMonth',

  data: () => ({
    loading: false,
    today: moment().format('YYYY-MM-DD'),
    focus: moment().format('YYYY-MM-DD'),
    type: 'month',
    typeToLabel: {
      month: 'Month',
      week: 'Week',
      day: 'Day',
      '4day': '4 Days',
    },
    start: null,
    end: null,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
  }),

  props: {
    loadCalendarEvents: {
      type: Function,
      default: () => {}
    },
    parentObject: {
      type: Object,
      default: () => {}
    }
  },

  watch: {
    parentObjectId (value, before) {
      if (value && value !== before) {
        this.loadEvents()
      }
    }
  },

  computed: {
    startDate () {
      if (!this.selectedEvent.item) {
        return moment(this.selectedEvent.start).format('DD.MM.YYYY')
      }
      return moment(this.selectedEvent.item.dateStart).format('DD.MM.YYYY')
    },

    endDate () {
      if (!this.selectedEvent.item) {
        return moment(this.selectedEvent.end).format('DD.MM.YYYY')
      }
      return moment(this.selectedEvent.item.dateEnd).format('DD.MM.YYYY')
    },

    parentObjectId () {
      return (this.parentObject && this.parentObject.id) || null
    },

    title () {
      const { start, end } = this
      if (!start || !end) {
        return ''
      }

      const startMonth = this.monthFormatter(start)
      const endMonth = this.monthFormatter(end)
      const suffixMonth = startMonth === endMonth ? '' : endMonth

      const startYear = start.year
      const endYear = end.year
      const suffixYear = startYear === endYear ? '' : endYear

      const startDay = start.day + this.nth(start.day)
      const endDay = end.day + this.nth(end.day)

      switch (this.type) {
        case 'month':
          return `${startMonth} ${startYear}`
        case 'week':
        case '4day':
          return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`
        case 'day':
          return `${startMonth} ${startDay} ${startYear}`
      }
      return ''
    },

    monthFormatter () {
      return this.$refs.calendar.getFormatter({
        timeZone: 'UTC', month: 'long'
      })
    },
  },

  mounted () {
    this.$refs.calendar.checkChange()
    this.loadEvents()
  },

  created () {
  },

  methods: {

    openEvent (event) {
      this.$router.push(event.link)
      // window.open(event.link, '_blank')
    },

    loadEvents () {
      this.events = []
      this.loading = true
      this.loadCalendarEvents(this.start, this.end).then(events => {
        console.log('events', events)
        this.events = events
        this.loading = false
      })
    },

    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
    },

    getEventColor (event) {
      return event.color
    },

    setToday () {
      this.focus = this.today
    },

    prev () {
      this.$refs.calendar.prev()
    },

    next () {
      this.$refs.calendar.next()
    },

    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.selectedElement = nativeEvent.target
        setTimeout(() => this.selectedOpen = true, 10)
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        setTimeout(open, 10)
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },

    updateRange ({ start, end }) {
      // You could load events from an outside source (like database) now that we have the start and end dates on the calendar
      if (start.date && end.date) {
        this.start = start
        this.end = end
        this.loadEvents()
      }
    },

    nth (d) {
      return d > 3 && d < 21
        ? 'th'
        : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10]
    }
  }
}
</script>

<style>
.no-underline {
  text-decoration: none !important;
}
</style>
